module.exports = __webpack_public_path__ + "img/round.6dab48d4.png";